import React, { Component } from "react";
import PropTypes from "prop-types";
import KeshanCarousel from "react-keshan-carousel";
import classNames from "classnames";
import { ReactComponent as PreviousIcon } from "../../images/chevron-icon-left.svg";
import { ReactComponent as NextIcon } from "../../images/chevron-icon-right.svg";

// Components
import IconButton from "../Atoms/IconButton";

// Stylesheets
import "react-keshan-carousel/lib/keshan-carousel.css";
import "./NewCarousel.scss";

export default class NewCarousel extends Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.any,
    showArrows: PropTypes.bool,
    ref: PropTypes.any,
  };

  static defaultProps = {
    showArrows: true,
  };

  onPrevClick = () => {
    return this.Carousel._slidePrev();
  };

  onNextClick = () => {
    return this.Carousel._slideNext();
  };

  renderArrow = (direction) => {
    if (!this.props.showArrows) {
      return null;
    }

    const className = classNames("slide_nav", {
      previous: direction === "left",
      next: direction === "right",
    });

    let iconProps = { className: "icon slide_icon" };
    let ariaLabel = "Previous";
    let onClick = this.onPrevClick;
    let Icon = PreviousIcon;

    if (direction === "right") {
      ariaLabel = "Next";
      onClick = this.onNextClick;
      Icon = NextIcon;
    }

    return (
      <IconButton className={className} ariaLabel={ariaLabel} onClick={onClick}>
        <Icon {...iconProps} />
      </IconButton>
    );
  };

  render() {
    const classes = classNames("new_carousel", this.props.className);

    const { className, ref, ...rest } = this.props;

    return (
      <div className={classes}>
        {this.renderArrow("left")}

        <KeshanCarousel ref={(c) => (this.Carousel = c)} {...rest}>
          {this.props.children}
        </KeshanCarousel>

        {this.renderArrow("right")}
      </div>
    );
  }
}
